import { Link } from "react-router-dom";
import { useGetTasksQuery } from "../../features/tasks/tasksApi";
import Sidebar from "../Sidebar/Sidebar";
import Task from "../Task/Task";
import { useDispatch, useSelector } from "react-redux";


export default function Home() {
  //Variables
  const { projects, searchText } = useSelector((state) => state.filter);
  const { data: tasksData } = useGetTasksQuery();
  const tasks = tasksData || [];


  //Functions

  const filterByProjects = (task) => {
    if (projects.length > 0) {
      return !projects.includes(task?.project?.projectName);
    }
    return true;
  };
  const filterBySearchText = (task) => {
    if (searchText?.length > 0) {
      return (task?.taskName).toLowerCase().includes(searchText.toLowerCase());
    }
    return true;
  };


  //JSX
  return (
    <>
      <Sidebar />
      <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
            <Link to="/tasks/add" className="lws-addnew group">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                stroke="currentColor" className="w-6 h-6 group-hover:text-indigo-500">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>

              <span className="group-hover:text-indigo-500">Add New</span>
            </Link>
          </div>
          <div className="lws-task-list">
            {tasks.filter(filterByProjects).filter(filterBySearchText).map(task => (<Task key={task.id} task={task} />))}
          </div>
        </main>
      </div>

    </>
  );
}
